'use client';

import Link from '@eliadmin/core/src/components/link';

import { useState } from 'react';

import type { TDynamicData } from '../../types/dynamic-data';

import { cn } from '@eliadmin/core/src/utils/style-utils';
import { Heading } from '../shared/heading';
import { Reveal } from '../shared/reveal';
import { Button } from '@eliadmin/core/src/components/ui/button';
import { GrCart } from 'react-icons/gr';

export function Operations({ operations, title }: { operations: TDynamicData[]; title: string }) {
  const [activeOperationId, setActiveOperationId] = useState<number>(operations[0].id);

  const activeOperation = operations.find(operation => operation.id === activeOperationId);

  const locationURL =
    activeOperation?.fields[1].value && activeOperation?.fields[0].value
      ? encodeURI(
          `https://maps.google.com/maps?width=100%25&amp;height=600&amp;hl=en&amp;q=${
            activeOperation?.fields[1].value + ' ' + activeOperation?.fields[0].value
          }(My%20Business%20Name)&amp;t=&amp;z=14&amp;ie=UTF8&amp;iwloc=B&amp;output=embed`,
        ).replace(/&amp;/g, '&')
      : activeOperation?.fields[1].value && activeOperation?.fields[0].value
        ? encodeURI(
            `https://maps.google.com/maps?width=100%25&amp;height=600&amp;hl=en&amp;q=${
              activeOperation?.fields[1].value + ' ' + activeOperation?.fields[0].value
            }(My%20Business%20Name)&amp;t=&amp;z=14&amp;ie=UTF8&amp;iwloc=B&amp;output=embed`,
          ).replace(/&amp;/g, '&')
        : 'https://maps.google.com/maps?width=100%25&amp;height=600&amp;hl=en&amp;q=S%C3%A1rospatak,%20Hat%C3%A1r%20%C3%BAt%202/B,%203950%20Hungary+(My%20Business%20Name)&amp;t=&amp;z=14&amp;ie=UTF8&amp;iwloc=B&amp;output=embed'.replace(
            /&amp;/g,
            '&',
          );

  return (
    <div
      className={cn(
        'custom-section',
        'mb-16 flex flex-col items-center justify-center gap-12 sm:mb-24 sm:gap-16',
      )}
    >
      <Heading className="items-center justify-center text-center" title={title} />
      <div
        className={cn(
          'custom-container',
          'flex w-full flex-col items-start justify-start gap-8 sm:gap-12 md:flex-row md:items-start md:justify-between lg:gap-24',
        )}
      >
        <div className="flex w-full flex-col items-start justify-start gap-8 sm:gap-12 md:max-w-[600px] lg:gap-16">
          <div className="flex w-full flex-col items-start justify-start gap-4 sm:gap-6">
            {operations.map(operation => {
              const isActive = activeOperationId === operation.id;

              return (
                <div
                  onClick={() => setActiveOperationId(operation.id)}
                  key={operation.id}
                  className={cn(
                    'w-full cursor-pointer border-2 border-primary p-4 text-sm text-primary transition-all sm:p-6 sm:text-base lg:text-lg',
                    isActive
                      ? 'cursor-not-allowed bg-primary font-bold text-white'
                      : 'bg-transparent font-normal text-primary hover:bg-primary/5',
                  )}
                >
                  {operation.name}
                </div>
              );
            })}
          </div>
          <Reveal>
            <Button asChild className="w-full sm:w-fit">
              <Link prefetch={false} href={'/eshop'}>
                <GrCart size={24} className="mr-2" />
                Eshop
              </Link>
            </Button>
          </Reveal>
        </div>
        <iframe title={`Mapa prevádzky: ${activeOperation?.name || title}`} className="aspect-square w-full max-w-[900px]" src={locationURL}></iframe>
      </div>
    </div>
  );
}
